<template>
    <div>
        <Head :title="`${form.name}`"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link
                class="text-indigo-400 hover:text-indigo-600"
                :href="$route('types.index')"
            >
                Тип рибалки
            </Link>
            <span class="text-indigo-400 font-medium">/</span>
            {{ form.name }}
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update" enctype="multipart/form-data">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Назва"/>
                    <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Опис"/>
                    <text-input
                        v-model="form.coefficient"
                        :error="form.errors.coefficient"
                        class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Коефіцієнт ціни"
                    />
                    <checkbox v-model="form.is_24_hours_event" :error="form.errors.is_24_hours_event"
                              label="24 часа"/>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button class="text-red-600 hover:underline" tabindex="-1" type="button"
                            @click.prevent="destroy">
                        Видалити
                    </button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Обновити
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import DragAndDrop from "@/Shared/DragAndDrop.vue";
import Checkbox from "@/Shared/Checkbox.vue";

export default {
    components: {
        Checkbox,
        DragAndDrop,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
    },
    layout: Layout,
    props: {
        type: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                _method: 'put',
                name: this.type.name,
                description: this.type.description,
                is_24_hours_event: this.type.is_24_hours_event,
                coefficient: this.type.coefficient
            }),
        }
    },
    methods: {
        update() {
            this.form.post(this.$route('types.update',this.type.id))
        },
        destroy() {
            if (confirm('Ви впевнені що хочете видалити тип рибалки?')) {
                this.$inertia.delete(this.$route('types.destroy',this.type.id))
            }
        }
    },
}
</script>
